import React from 'react'
import './whoweare.scss';

const Whoweare = () => {
  return (
    <>
      <section className='scale_main'>
        <div className='custom-container'>
          <div className='inner_scale'>
          <h2>Launchpad Leadership</h2>
          <div className='parent_team'>
            <div className='card_team'>
              <img src='\assets\issac.png' className='img-fluid'/>
              <h3>Isaac Joshua</h3>
              <h4>CEO</h4>
              <p>Leads GEMS platform with $200M+ in fundraising for Web3 projects and a network of 4,300+ affiliates across 140+ countries. Former eToro executive with extensive crypto investment experience.</p>
            </div>
            <div className='card_team'>
              <img src='\assets\adan.png' className='img-fluid'/>
              <h3>Adan Kedem</h3>
              <h4>VP Marketing</h4>
              <p>Founder of Crypto Valley IL, leading Gems' marketing and community initiatives. Over a decade of experience in blockchain marketing and community development.</p>
            </div>
            <div className='card_team'>
              <img src='\assets\gai.png' className='img-fluid'/>
              <h3>Gai Winter</h3>
              <h4>VP Business Development</h4>
              <p>Fintech and gaming veteran bringing crucial experience in market analysis and investor relations, with an extensive network of affiliates and media buyers.</p>
            </div>
          </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Whoweare
